import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ICreateAccountRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';
import TokenUtils from 'utils/TokenUtils';

export const createCreateAccountThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(ApplyProcessActionTypes.CreateAccount, async (data: ICreateAccountRequest) => {
    const { accessToken, refreshToken } = await api.createAccount(data);

    TokenUtils.setTokens({ accessToken, refreshToken });
  });
